import type { AppModule } from '@shared/presentation/router/composition.js';

/**
 * The two answers that are not a screen: "it does not exist" and "not for you".
 *
 * The 404 is public on purpose: an address that does not exist should say so
 * whether there is a session or not, instead of bouncing to the login screen and
 * suggesting the screen exists and only permission is missing.
 *
 * The 403 is the opposite case and lives **inside** the shell: getting there
 * means there is a session, so the menu belongs on screen — it is the way out.
 * It declares no permission of its own, or the guard would bounce the very
 * screen it bounces people to.
 */
export const errorsModule: AppModule = {
  name: 'errors',
  routes: [
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: () => import('./presentation/NotFoundView.vue'),
      meta: { public: true },
    },
  ],
  layoutRoutes: [
    {
      path: 'forbidden',
      name: 'forbidden',
      component: () => import('./presentation/ForbiddenView.vue'),
    },
  ],
};
